import React from "react";
import { connect } from "react-redux";
import { Popup, Button } from "devextreme-react";
import { openCloseModalEliminarTrabajador, setDataSelected } from "../actions";
class ModalEliminarTrabajador extends React.PureComponent {
  handleClose = () => {
    const { onOpen } = this.props;
    onOpen(false, {});
  }
  handleEliminar = () => {
    const { onOpen, onSetDataSelected, dataSelected, worker } = this.props;
    dataSelected.newWorkers = [...dataSelected.newWorkers.filter((data, index) => index !== worker)];
    dataSelected.isWorkersUpdate = true;
    onOpen(false, {});
    onSetDataSelected({ ...dataSelected });
  }

  render() {
    const { isOpenModalEliminarTrabajador } = this.props;
    return (
      <Popup
        title={`Eliminar Trabajador`}
        showCloseButton
        dragEnabled={false}
        onHiding={this.handleClose}
        visible={isOpenModalEliminarTrabajador}
        width={500}
        height={200}
        contentComponent={() => (
          <div style={{ textAlign: "center" }} className="modal-delete-mantenedor">
            ¿Estás seguro que quieres eliminar el trabajador?
            <div className="button-row">
              <div>
                <Button text="Cancelar" style={{ marginRight: 5 }} onClick={this.handleClose} />
              </div>
              <div>
                <Button text="Eliminar" type="danger" onClick={this.handleEliminar} useSubmitBehavior />
              </div>
            </div>
          </div >
        )
        }
      />
    );
  }
}
const mapStateToProps = (state) => ({
  isOpenModalEliminarTrabajador: state.confirmacionSolicitudesAgendaSel.isOpenModalEliminarTrabajador,
  dataSelected: state.confirmacionSolicitudesAgendaSel.dataSelected,
  worker: state.confirmacionSolicitudesAgendaSel.worker,
});
const mapDispatchToProps = (dispatch) => ({
  onOpen: (open, worker) => dispatch(openCloseModalEliminarTrabajador(open, worker)),
  onSetDataSelected: (data) => dispatch(setDataSelected(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(ModalEliminarTrabajador);
